module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAfCAYAAAAmyadiAAAAGklEQVQImWPYu/3/JSYGBgZ+EMEwaAgGBj0ADfYDv1JoXekAAAAASUVORK5CYII="